module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4r6r9r-100320fa8a5680fd66b6dfd5112ce013.svg";